<template>
  <div class="dashboard-skeleton">
    <!-- Row 1: KPI Cards -->
    <div class="row g-4 mb-4">
      <div v-for="i in 4" :key="'kpi-'+i" class="col-xl-3 col-md-6">
        <div class="skeleton-kpi-card">
          <div class="d-flex justify-content-between mb-3">
            <div class="skeleton-box" style="width: 40%; height: 16px;"></div>
            <div class="skeleton-box" style="width: 38px; height: 38px; border-radius: 10px;"></div>
          </div>
          <div class="skeleton-box mb-2" style="width: 60%; height: 32px;"></div>
          <div class="d-flex justify-content-between mt-auto">
            <div class="skeleton-box" style="width: 30%; height: 14px;"></div>
            <div class="skeleton-box" style="width: 30%; height: 14px;"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Row 2: Charts (Registration & Channels) -->
    <div class="row g-4 mb-4">
      <div class="col-lg-8">
        <div class="skeleton-chart-card d-flex flex-column">
          <div class="skeleton-box mb-2" style="width: 30%; height: 20px;"></div>
          <div class="skeleton-box mb-4" style="width: 50%; height: 14px;"></div>
          <div class="skeleton-box mt-auto" style="width: 100%; height: 260px;"></div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="skeleton-chart-card d-flex flex-column">
          <div class="skeleton-box mb-2" style="width: 40%; height: 20px;"></div>
          <div class="skeleton-box mb-4" style="width: 60%; height: 14px;"></div>
          <div class="skeleton-box mx-auto rounded-circle my-4" style="width: 180px; height: 180px;"></div>
          <div class="mt-auto">
             <div v-for="j in 3" :key="'chan-'+j" class="d-flex justify-content-between mb-2">
                <div class="skeleton-box" style="width: 40%; height: 14px;"></div>
                <div class="skeleton-box" style="width: 20%; height: 14px;"></div>
             </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Row 3: Point Activity & Tier Movement -->
    <div class="row g-4 mb-4">
      <div class="col-lg-8">
        <div class="skeleton-chart-card d-flex flex-column">
          <div class="skeleton-box mb-2" style="width: 30%; height: 20px;"></div>
          <div class="skeleton-box mb-4" style="width: 50%; height: 14px;"></div>
          <div class="skeleton-box mt-auto" style="width: 100%; height: 260px;"></div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="skeleton-chart-card d-flex flex-column">
          <div class="skeleton-box mb-2" style="width: 40%; height: 20px;"></div>
          <div class="skeleton-box mb-4" style="width: 60%; height: 14px;"></div>
          <div class="skeleton-box mt-auto" style="width: 100%; height: 260px;"></div>
        </div>
      </div>
    </div>

    <!-- Row 4: Tables -->
    <div class="row g-4">
      <div v-for="i in 3" :key="'table-'+i" class="col-xl-4 col-md-12">
        <div class="skeleton-chart-card">
          <div class="skeleton-box mb-2" style="width: 40%; height: 20px;"></div>
          <div class="skeleton-box mb-4" style="width: 60%; height: 14px;"></div>
          <div class="mt-4">
              <div v-for="j in 4" :key="'row-'+j" class="d-flex align-items-center mb-4">
                <div class="skeleton-box me-3" style="width: 32px; height: 32px; border-radius: 50%;"></div>
                <div class="flex-grow-1">
                    <div class="skeleton-box mb-1" style="width: 70%; height: 14px;"></div>
                    <div class="skeleton-box" style="width: 40%; height: 12px;"></div>
                </div>
                <div class="skeleton-box ms-3" style="width: 20%; height: 14px;"></div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'DashboardSkeleton'
}
</script>

<style scoped>
.skeleton-box {
    background: #e2e8f0;
    border-radius: 6px;
    position: relative;
    overflow: hidden;
}

.skeleton-box::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0,
        rgba(255, 255, 255, 0.4) 20%,
        rgba(255, 255, 255, 0.6) 60%,
        rgba(255, 255, 255, 0)
    );
    animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
    100% {
        transform: translateX(100%);
    }
}

.skeleton-kpi-card {
    background: #ffffff;
    border: 1px solid #f1f5f9;
    border-radius: 12px;
    padding: 24px;
    min-height: 160px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.skeleton-chart-card {
    background: #ffffff;
    border: 1px solid #f1f5f9;
    border-radius: 16px;
    padding: 28px;
    height: 100%;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
</style>
